const locale = {
  INTRODUCTION: "መግቢያ",
  INTRODUCTION_CONTENT:
    "የወጣቶች የስራ ፕሮግራም ወጣት ግለሰቦችን ስልጣን ለመስጠት እና በሰራተኛው ስኬታማ ለመሆን የሚያስፈልጓቸውን ክህሎቶች፣ ልምዶችእና እድሎች ለማስታጠቅ የተዘጋጀ የለውጥ መርሃ ግብር ነው።  ይህ ፕሮግራም የወጣቶች አቅም ለኢኮኖሚ ዕድገትና ማህበረሰባዊ ዕድገት መንቀሳቀሻ ኃይል መሆኑን በመገንዘብ በትምህርትና በሥራ መካከል ያለውን ልዩነት በማጥበብ ለበለፀገ የወደፊት ሕይወት መንገድ ይጠርጋል። በዛሬው ጊዜ ብዙ ወጣቶች የሥራ ልምድ ወይም ችሎታ በማጣት ወደ ሥራው ዓለም ለመግባት በሚሞክሩበት ጊዜ ተፈታታኝ ሁኔታዎች ያጋጥሟቸዋል።  የወጣቶች ስራ ፕሮግራም ተሳታፊዎች እነዚህን እንቅፋቶች ተቋቁሞ የስራ ግባቸው ላይ እንዲደርሱ ለማገዝ የሚያስችል የተሟላ ድጋፍና ሃብት በመስጠት እነዚህን መሰናዶዎች ያስተናግዳሉ። በወጣቶች እድገት እና ሀይል ላይ ኢንቨስት በማድረግ፣ የእነርሱን የግል ስኬት ማሳደግ ብቻ ሳይሆን ለማኅበረሰቦቻችን አጠቃላይ እድገት እና ደህንነት አስተዋጽኦ እናበረክታለን።",
  PROGRAM_OBJECTIVES: "የፕሮግራም ዓላማዎች",
  OBJECTIVE_CONTENT:
    "የወጣቶች ስራ ፕሮግራም ሶስት ዋና ዋና ዓላማዎች አሉት። በመጀመሪያ ደረጃ, ፕሮግራሙ በችሎታ ልማት ላይ ያተኮረ ነው, መስሪያ ቤቶች, ስልጠና ክፍለ ጊዜዎች, እንዲሁም የተሳታፊዎችን ችሎታ ለማጎልበት በእጅ ተሞክሮ ያቀርባል. የሐሳብ ልውውጥ ማድረግን፣ ችግሮችን መፍታትንና የቡድን ሥራን በመሳሰሉ አስፈላጊ ክህሎቶች በማስታጠቅ በመረጡት መስክ ከሁኔታዎች ጋር ራሳቸውን ማስማማት የሚችሉና ጠቃሚ አስተዋጽኦ የሚያበረክቱ እንዲሆኑ እንረዳቸዋለን። በሁለተኛ ደረጃ ፣ ፕሮግራሙ ለተሳታፊዎች ትርጉም ያለው የሥራ ልምድ ይሰጣል ። ተሳታፊዎች በሙያቸው፣ በሥልጠናወይም በበጋ ወቅት በሚሰሩ ሥራዎች አማካኝነት ችሎታቸውንና እውቀታቸውን ተግባራዊ በሆነ ሁኔታ ላይ እንዲውሉ ያስችላቸዋል። እነዚህ ተሞክሮዎች በራስ የመተማመን ስሜት ንጹህ ከመሆናቸውም በላይ ጠንካራ የሥራ ሥነ ምግባርና ሙያዊ ድረ ገጽ እንዲኖር አስተዋጽኦ ያደርጋል። በመጨረሻም, ፕሮግራሙ ወሳኝ የስራ መመሪያ እና ድጋፍ ይሰጣል. ተሳታፊዎቹ መመሪያ ከሚሰጡ፣ ክህሎታቸውን ከሚያካፍሉ፣ እና የስራ እቅድ ውስብስብ ነገሮችን በመጓዝ ረገድ ከሚረዱ አማካሪዎች ጋር ተቆራኝተዋል። በማስተማሪያነት፣ በስራ ምክር፣ እና በዳሰሳ እንቅስቃሴዎች፣ ተሳታፊዎች የስራ መንገዳቸውን ግልፅ ያደርጋሉ፣ በእውቀት ላይ ያሉ ውሳኔዎችን ያደርጋሉ፣ እንዲሁም ግቦቻቸውን ውጤታማ በሆነ መንገድ ለመከታተል የሚያስችላቸውን ሀብት ያገኛሉ።",
  IMPACT: "ተፅዕኖ እና ስኬት ታሪኮች",
  IMPACT_CONTENT:
    "የወጣቶች የስራ ፕሮግራም ጉልህ ተፅዕኖ እና ስኬት ታሪኮች ተመልክቷል። ፕሮግራሙን ያጠናቀቁ ተሳታፊዎች በተለያዩ ኢንዱስትሪዎች ውስጥ ሥራ ለማግኘት፣ ከፍተኛ ትምህርት ለመከታተልና በማኅበረሰባቸው ውስጥ መሪ ለመሆን በቅተዋል። ስኬታቸው የግል እድገታቸውን የሚያንጸባርቅ ከመሆኑም በላይ የወጣቶችን ኃይል የመስጠት እና ችሎታቸውን የመክፈት ችሎታ እንዳላቸውም ያሳያል። ከዚህም በላይ ይህ ተጽዕኖ በግለሰብ ደረጃዎች ስኬታማ ከመሆን ያለፈ ነገርንም ይዟል ። ተሳታፊዎች ምርታማ የሰራተኞች አባላት እየሆኑ ሲሄዱ ለክልላቸው የኢኮኖሚ እድገትና መረጋጋት አስተዋፅኦ ያደርጋሉ። ጥሩ ችሎታ ያለው የሠራተኛ ኃይል በማዳበር ላይ ትኩረት የደረጉት ፕሮግራሞች የንግድ ድርጅቶችን ፣ ማኅበረሰቦችንና ኅብረተሰቡን የሚጠቅሙ ጥሩ ውጤት ያስገኛሉ ። ",
  CONCLUSION: "መደምደሚያ",
  CONCLUSION_CONTENT:
    "የወጣቶች ስራ ፕሮግራም ወደፊት እጅግ ጠቃሚ የሆነ ኢንቨስትመንት ነው። ወጣት ግለሰቦች የሚያስፈልጋቸውን ክህሎት፣ ልምድእና መመሪያ በመስጠት፣ የተካነ የሠራተኛ ኃይል ን በማዳበር፣ የኢኮኖሚ እድገትን በማጠናከርና በማኅበረሰቦቻችን ላይ ብሩህ የወደፊት ሕይወት በመፍጠር ላይ እንገኛለን። አንድ ላይ ሆነን ወጣቶች በነገው እድሜ የበለፀጉ አርክቴክቶች ሲሆኑ ኃይል መስጠት እና አቅማቸውን ሙሉ በሙሉ መክፈት እንችላለን።",

  // Youth Portal Content
  YOUTH: {
    WELCOME_TITLE: "እንኳን ወደ CYPMS በደህና መጡ",
    WELCOME_SUBTITLE: "የእድገት መግቢያ በር",
    WHAT_IS_TITLE: "CYPMS ምንድን ነው?",
    WHAT_IS_CONTENT_1:
      "የኮዲስ ወጣቶች ፕሮግራም አስተዳደር ስርዓት (CYPMS) እንደ MBSYEP እና ሌሎች ያሉ የDC ወጣት የስራ ቅጥር እና የልማት ፕሮግራሞች ውስጥ ያለዎትን ጉዞ ለመደገፍ የተነደፈ ብልህ፣ ደህንነቱ የተጠበቀ እና ለተጠቃሚ ምቹ የሆነ መድረክ ነው።",
    WHAT_IS_CONTENT_2:
      "ለስራ ለማመልከት፣ የስራ ሰዓትዎን ለመከታተል ወይም ለመክፈል እየፈለጉ ቢሆንም — CYPMS በአንድ ቦታ የሚያስፈልግዎትን ሁሉ ይዟል።",
    FEATURES_TITLE: "ስለ CYPMS ማወቅ ያለብዎት ነገሮች",
    FEATURES_INTRO: "አንዴ ከተመዘገቡ በኋላ ማድረግ የሚችሉት ነገሮች እነሆ፡-",
    FEATURES: {
      ENROLL: {
        TITLE: "በፕሮግራሞች ውስጥ ይመዝገቡ",
        CONTENT: "በፖርታሉ በኩል ቀጥታ ለወጣቶች የስራ ቅጥር ወይም የሥልጠና ፕሮግራሞች ያመልክቱ።",
      },
      EXPLORE: {
        TITLE: "የሥራ እድሎችን ያስሱ እና ያመልክቱ",
        CONTENT: "ክፍት የሥራ እድሎችን ይመልከቱ፣ በቀላሉ ያመልክቱ እና የማመልከቻ ሁኔታዎን ይከታተሉ።",
      },
      TIMESHEETS: {
        TITLE: "የሰዓት መቆጣጠሪያ ይላኩ",
        CONTENT: "የስራ ሰዓትዎን በየቀኑ ይመዝግቡ እና የሰዓት መቆጣጠሪያ ታሪክዎን በእውነተኛ ጊዜ ይመልከቱ።",
      },
      TRACK_PAY: {
        TITLE: "ክፍያዎን ይከታተሉ",
        CONTENT:
          "ምን ያህል እንዳገኙ ይመልከቱ፣ የደመወዝ ሰነዶችን ያውርዱ እና የድሮውን የደመወዝ መረጃ ይመልከቱ።",
      },
      FORMS: {
        TITLE: "የሚጠየቁ ቅጾችን ይሙሉ",
        CONTENT: "W-4, DC D-4, የስምምነት ቅጾችን እና ሌሎችንም ይሙሉ እና ያስገቡ—ሁሉም በመስመር ላይ።",
      },
      AI_ASSISTANCE: {
        TITLE: "በሰው ሰራሽ አዕምሮ የተጎናጸፈ እርዳታ ይጠቀሙ",
        CONTENT:
          "እርዳታ ይፈልጋሉ? ተገኘን የምናገኘው ምክትል ረዳት መድረኩን በመዳሰስ፣ የራስ ገጽታን በመጻፍ ወይም ተመሳሳይ የሥራ እድሎችን ማግኘትን መመራት ይችላል 24/7።",
      },
      ORIENTATION: {
        TITLE: "የስልጠና እና የማረጋገጫ ፕሮግራሞችን ይሙሉ",
        CONTENT:
          "በCYPMS ውስጥ ያሉ የማስተዋወቂያ መሳሪያዎች፣ ፈተናዎች እና የመማሪያ ቁሳቁሶች ጋር ለፕሮግራም ተሞክሮዎ ይዘጋጁ።",
      },
      STAY_INFORMED: {
        TITLE: "ሁልጊዜ መረጃው ይደርስዎት",
        CONTENT:
          "በተቀናጀው የመልዕክት መተላለፊያ ማዕከል በኩል ከDOES ወይም ከአስተናጋጅ ቦታዎ እውነተኛ የጊዜ ዝማኔዎችን፣ ማስታወቂያዎችን እና ማስጠንቀቂያዎችን ይቀበሉ።",
      },
    },
    NEXT_STEPS_TITLE: "ከምዝገባ በኋላ ምን ይሆናል?",
    NEXT_STEPS: [
      "መረጃዎን ይሙሉ - መረጃዎን፣ ትምህርቶን እና ፍላጎቶን ይጨምሩ",
      "አስፈላጊ ሰነዶችን ያስገቡ - የወላጅ ስምምነት፣ የመኖሪያ ማረጋገጫ፣ የግብር ቅጾች",
      "የመምሪያ እና የማረጋገጫ ፈተናዎችን ይውሰዱ",
      "ሥራዎችን ያስሱ እና ያመልክቱ",
      "መስራት እና የሰዓት መቆጣጠሪያ መመዝገብ ይጀምሩ",
    ],
  },

  // Host Portal Content
  HOST: {
    WELCOME_TITLE: "እንኳን ወደ CYPMS በደህና መጡ",
    WELCOME_SUBTITLE: "የወደፊት የሥራ ኃይልን ማብቃት",
    WHAT_IS_TITLE: "CYPMS ምንድን ነው?",
    WHAT_IS_CONTENT_1:
      "የኮዲስ ወጣቶች ፕሮግራም አስተዳደር ስርዓት (CYPMS) እንደ MBSYEP እና ሌሎች በDC የወጣቶች የስራ ቅጥር ፕሮግራሞች ውስጥ በንቃት እንዲሳተፉ እንደ የእርስዎ አስተናጋጅ ድርጅቶችን ለመርዳት የተገነባ ደህንነቱ የተጠበቀ እና ለመጠቀም ቀላል የሆነ መድረክ ነው።",
    WHAT_IS_CONTENT_2:
      "ድርጅትዎን ከመመዝገብ እስከ የሥራ ቦታዎችን ማስተዳደር፣ የሥራ እድሎችን መለጠፍ፣ ወጣቶችን መቆጣጠር እና ሰዓቶችን ማፅደቅ ድረስ — CYPMS ሁሉንም በአንድ ቦታ ያቀርባል።",
    FEATURES_TITLE: "ስለ CYPMS ማወቅ ያለብዎት ነገሮች",
    FEATURES_INTRO: "ድርጅትዎ ከተመዘገበ በኋላ ማድረግ የሚችሉት ነገሮች እነሆ፡-",
    FEATURES: {
      ENROLL: {
        TITLE: "ድርጅትዎን በፕሮግራም ውስጥ ይመዝግቡ",
        CONTENT: "በወጣቶች የስራ ቅጥር ፕሮግራሞች ውስጥ ለመሳተፍ ይመዝገቡ እና በየዓመቱ ተሳትፎዎን ያስተዳድሩ።",
      },
      WORKSITES: {
        TITLE: "የሥራ ቦታዎችን እና ቡድኖችን ያዘጋጁ",
        CONTENT:
          "የሥራ ቦታዎችን ይፍጠሩ እና ያስተዳድሩ፣ ተቆጣጣሪዎችን ይጨምሩ እና ለእያንዳንዱ ቦታ ሚናዎችን እና አቅሞችን ይወስኑ።",
      },
      POST_JOBS: {
        TITLE: "የሥራ እድሎችን ይለጥፉ",
        CONTENT:
          "ለወጣቶች የሥልጠና ወይም የቅጥር እድሎችን ይለጥፉ። በመነሳሳት ላይ የተመሰረተ የስራ ማስታወቂያዎችን ለማመንጨት የሰው ሰራሽ አዕምሮ ረዳት መጠቀም ይችላሉ።",
      },
      APPLICATIONS: {
        TITLE: "የሥራ ማመልከቻዎችን ይመልከቱ እና ያስተዳድሩ",
        CONTENT:
          "በለጠፉት ሥራዎች ላይ ማን እንዳመለከተ ይመልከቱ እና በማመልከቻ ዝርዝሮች ላይ በመመስረት በእውቀት ላይ የተመሰረተ ምርጫዎችን ያድርጉ።",
      },
      SUPERVISE: {
        TITLE: "ወጣቶችን ይመድቡ እና ይቆጣጠሩ",
        CONTENT:
          "ተቆጣጣሪዎች የወጣቶችን አፈጻጸም መቆጣጠር፣ አስተያየት መመዝገብ እና የመማር ልምዳቸውን መደገፍ ይችላሉ።",
      },
      APPROVE_TIMESHEETS: {
        TITLE: "የሰዓት መቆጣጠሪያዎችን ማጽደቅ",
        CONTENT:
          "የወጣቶች የቀረቡ የሰዓት መቆጣጠሪያዎችን በፖርታሉ በኩል ይገምግሙ እና ያጸድቁ—ትክክለኛ እና በጊዜው የደሞዝ ክፍያ ሂደትን ያረጋግጡ።",
      },
      PROGRAM_FORMS: {
        TITLE: "የፕሮግራም ቅጾችን ያስገቡ",
        CONTENT:
          "ክስተቶችን ሪፖርት ያድርጉ፣ ዝውውሮችን ይጠይቁ፣ ወይም ማቆሚያዎችን በተቀላጠፈ የመስመር ላይ ቅጾች አማካይነት ያስገቡ።",
      },
      NOTIFICATIONS: {
        TITLE: "በእውነተኛ ጊዜ ማሳወቂያዎችን ይቀበሉ",
        CONTENT:
          "ከDOES የስርዓት መልዕክቶች፣ ማስጠንቀቂያዎች እና አስፈላጊ ማስታወሻዎች ላይ ወቅታዊ መረጃ ይጠብቁ።",
      },
    },
    NEXT_STEPS_TITLE: "ከምዝገባ በኋላ ምን ይሆናል?",
    NEXT_STEPS: [
      "የድርጅቶን መገለጫ ይሙሉ - ቡድንዎን፣ ሚናዎችን እና የመገኛ ዝርዝሮችን ይጨምሩ",
      "በፕሮግራም ውስጥ ይመዝገቡ - በMBSYEP ወይም ተመሳሳይ ዘጋቢዎች ውስጥ ያለዎትን ፍላጎት ያረጋግጡ",
      "የሥራ ቦታዎችን ይፍጠሩ እና ተቆጣጣሪዎችን ይመድቡ - ወጣቶች እንዴት እንደሚስተናገዱ ያደራጁ",
      "የሥራ እድሎችን ያሳትሙ - የሚገኙ ሚናዎችን ዝርዝር እና ማመልከቻዎችን ይገምግሙ",
      "የሰዓት መቆጣጠሪያዎችን ያጸድቁ እና ወጣቶችን ይቆጣጠሩ - የወጣቶችን ተሳትፎ እና ተሳትፎ ያስተዳድሩ",
    ],
  },

  // Admin Portal Content
  ADMIN: {
    WELCOME_TITLE: "እንኳን ወደ CYPMS አስተዳዳሪ ፖርታል በደህና መጡ",
    WELCOME_SUBTITLE: "የፕሮግራም አስተዳደርን ማብቃት",
    WHAT_IS_TITLE: "CYPMS ምንድን ነው?",
    WHAT_IS_CONTENT_1:
      "የኮዲስ ወጣቶች ፕሮግራም አስተዳደር ስርዓት (CYPMS) እንደ MBSYEP እና ከዚያም በላይ ያሉ የወጣቶች የስራ ቅጥር ፕሮግራሞችን ለማስተዳደር፣ ለመቆጣጠር እና ለማሻሻል የDC መንግስት ሰራተኞችን በመሳሪያዎች የሚያስታጥቅ ዘመናዊ፣ ደህንነቱ የተጠበቀ መድረክ ነው።",
    WHAT_IS_CONTENT_2:
      "ምዝገባዎችን እየተከታተሉ፣ ሰነዶችን እያጸደቁ፣ የደሞዝ ክፍያ ፋይሎችን እየተዳደሩ ወይም ሪፖርቶችን እየተቀሩ ቢሆንም — የአስተዳዳሪ ፖርታል ሁሉንም በአንድ የተቀናጀ አከባቢ ውስጥ ይሰጣል።",
    FEATURES_TITLE: "ስለ CYPMS ማወቅ ያለብዎት ነገሮች",
    FEATURES_INTRO: "ወደ አስተዳዳሪ ፖርታል ከገቡ በኋላ ማድረግ የሚችሉት ነገሮች እነሆ፡-",
    FEATURES: {
      DASHBOARD: {
        TITLE: "በዳሽቦርድ አማካይነት የፕሮግራም እንቅስቃሴን ይቆጣጠሩ",
        CONTENT:
          "በወጣቶች ምዝገባዎች፣ በአስተናጋጅ ምዝገባዎች፣ በሂደት ላይ ባሉ ማረጋገጫዎች፣ የሰዓት መቆጣጠሪያ ሁኔታዎች እና ሌሎችም ላይ በእውነተኛ ጊዜ ውሂብ ይድረሱ—ሁሉም በአንድ ቅጽበታዊ ምስል ውስጥ።",
      },
      DOCUMENTATION: {
        TITLE: "ሰነዶችን ይገምግሙ እና ያጸድቁ",
        CONTENT:
          "በወጣቶች እና በአስተናጋጆች የቀረቡ ሰነዶችን ያጸድቁ ወይም ይከልክሉ፣ የስምምነት ቅጾችን፣ የብቁነት ማረጋገጫ፣ W-4/D-4 ቅጾችን፣ የማስተላለፍ እና የማቆም ጥያቄዎችን ጨምሮ።",
      },
      PAYROLL: {
        TITLE: "የደሞዝ ማስገቢያን ያስተዳድሩ",
        CONTENT:
          "የጸደቁ የሰዓት መቆጣጠሪያ ውሂብን ለደሞዝ አሰጣጦች እንደ Paycor/ADP ያጠቃልሉ እና ያስገቡ እና ለጂስትሪክቱ የፋይናንስ ስርዓት (DIFS) የሚገባ የሚጣጣሙ ፋይሎችን ያዘጋጁ።",
      },
      REPORTS: {
        TITLE: "ሪፖርቶችን ይድረሱ እና ያውጡ",
        CONTENT:
          "በተሳትፎ፣ በሥራዎች፣ በደሞዝ ክፍያ እና በተገዥነት ላይ ዝርዝር ሪፖርቶችን ያመንጩ። አዝማሚያዎችን ለማሰስ ማጣሪያዎችን ይጠቀሙ እና ለትንተና ወይም ለኦዲት ውሂብ ያውጡ።",
      },
      PROFILES: {
        TITLE: "የወጣቶች እና የአስተናጋጅ መገለጫዎችን ይመልከቱ",
        CONTENT:
          "የቀረቡ ቅጾችን፣ የእንቅስቃሴ ታሪክን እና የማረጋገጫ ሁኔታን ጨምሮ የወጣት ተሳታፊዎች እና የአስተናጋጅ ድርጅቶች ሁለቱንም ሰፊ መዝገቦችን ይፈልጉ እና ይመልከቱ።",
      },
      ONBOARDING: {
        TITLE: "የማስተዋወቂያ መሳሪያዎችን ይፍጠሩ እና ያስተዳድሩ",
        CONTENT:
          "ወጣቶች በምዝገባ እና በመመዝገቢያ ወቅት የሚያጠናቅቋቸው ስልጠና፣ የባንክ አገልግሎት እና የምስክር ወረቀት ፈተናዎችን ይገንቡ።",
      },
      USER_MANAGEMENT: {
        TITLE: "አስተዳዳሪ ተጠቃሚዎችን ይፍጠሩ እና ያስተዳድሩ",
        CONTENT:
          "አዲስ አስተዳዳሪ ተጠቃሚዎችን ይጨምሩ፣ ሚናዎችን እና ፈቃዶችን ይመድቡ እና ለተወሰኑ የስርዓት ገጽታዎች መዳረሻን ይቆጣጠሩ።",
      },
      COMMUNICATIONS: {
        TITLE: "ግንኙነቶችን ይላኩ",
        CONTENT:
          "በተቀናጀው የመልዕክት ስርዓት አማካይነት ለወጣቶች፣ ለአስተናጋጆች ወይም ለሌሎች አስተዳዳሪዎች ማስታወቂያዎችን፣ ማስጠንቀቂያዎችን እና መመሪያዎችን ያሰራጩ።",
      },
      SSO: {
        TITLE: "በActive Directory / OKTA አማካይነት ይግቡ",
        CONTENT:
          "DOES አስተዳዳሪዎች በActive Directory ወይም OKTA አማካይነት ደህንነቱ የተጠበቀ ነጠላ ምዝገባን በመጠቀም መግባት ይችላሉ፣ የተማከለ እና ደህንነቱ የተጠበቀ ማረጋገጫን ያረጋግጣል።",
      },
    },
    NEXT_STEPS_TITLE: "ከመግባት በኋላ ምን ይሆናል?",
    NEXT_STEPS: [
      "ቁልፍ እንቅስቃሴን ይቆጣጠሩ - የስርዓት አቀፍ እድገትን ለመከታተል ዳሽቦርዱን ይጠቀሙ",
      "ማረጋገጫዎችን ይገምግሙ - ቅጾችን ያስኪዱ፣ ሰነዶችን ያረጋግጡ እና ልዩ ሁኔታዎችን ያስተዳድሩ",
      "የደሞዝ ክፍያ እና ሪፖርት ማድረግን ያስተዳድሩ - የደሞዝ ክፍያ ውሂብን ያስገቡ፣ ይከታተሉ እና ያረጋግጡ",
      "የስርዓት ስራዎችን ይደግፉ - ተጠቃሚዎችን፣ ፕሮግራሞችን፣ ፈተናዎችን እና ሌሎችንም ይፍጠሩ",
      "በብቃት ይግባቡ - ባለድርሻ አካላትን በወቅታዊ መልዕክቶች ያሳውቁ",
    ],
  },

  // Parent Portal Content
  PARENT: {
    WELCOME_TITLE: "እንኳን ወደ CYPMS የወላጅ ፖርታል በደህና መጡ",
    WELCOME_SUBTITLE: "ተገናኝተው ይቆዩ፣ መረጃው ይድረስዎት",
    WHAT_IS_TITLE: "CYPMS ምንድን ነው?",
    WHAT_IS_CONTENT_1:
      "የኮዲስ ወጣቶች ፕሮግራም አስተዳደር ስርዓት (CYPMS) እንደ MBSYEP ያሉ የDC ወጣቶች የስራ ቅጥር ዘጋቢዎችን የሚደግፍ የተማከለ ዲጂታል መድረክ ነው። የወላጅ ፖርታል አሳዳጊዎች በእነዚህ ፕሮግራሞች ውስጥ የልጃቸውን ተሳትፎ ለመቆጣጠር እና ለመደገፍ ደህንነቱ የተጠበቀ መዳረሻ ይሰጣል።",
    WHAT_IS_CONTENT_2:
      "የስምምነት ቅጾችን ከማጽደቅ እስከ የሥራ ታሪክን መመልከት እና አስፈላጊ ዝማኔዎችን መቀበል ድረስ—CYPMS በእያንዳንዱ እርምጃ ከልጅዎ እድገት ጋር ተገናኝተው እንዲቆዩ ያረጋግጣል።",
    FEATURES_TITLE: "ስለ CYPMS ማወቅ ያለብዎት ነገሮች",
    FEATURES_INTRO: "ከተጋበዙ እና ከገቡ በኋላ ማድረግ የሚችሉት ነገሮች እነሆ፡-",
    FEATURES: {
      CONSENT: {
        TITLE: "የወላጅ ፈቃድ ጥያቄዎችን ማጽደቅ",
        CONTENT:
          "ልጅዎ በፕሮግራም ምዝገባው አካል የሆኑ የወላጅ ስምምነት ቅጾችን በቀላሉ ይፍቀዱ ወይም ይከልክሉ።",
      },
      PROFILES: {
        TITLE: "የተገናኙ የወጣቶች መገለጫዎችን ይመልከቱ",
        CONTENT:
          "እርስዎን እንደ ወላጃቸው ወይም አሳዳጊያቸው የለዩ ልጆች ሁሉ ዝርዝር ይመልከቱ፣ ከፕሮግራም ተሳትፎ ዝርዝሮቻቸው መዳረሻ ጋር።",
      },
      ENROLLMENT: {
        TITLE: "የምዝገባ ሁኔታን ይከታተሉ",
        CONTENT:
          "የግብር ቅጾችን፣ የስልጠና እና የምስክር ወረቀት ፈተናዎችን ማጠናቀቅን ጨምሮ የልጅዎን የምዝገባ እድገት ይከታተሉ።",
      },
      TIMESHEET: {
        TITLE: "የሰዓት መቆጣጠሪያ እና የሰዓት መቆጣጠሪያን ይመልከቱ",
        CONTENT:
          "በፕሮግራም ሳምንታት ውስጥ የልጅዎን የተመዘገበ ሰዓቶች፣ ተገኝነት እና የሰዓት መቆጣጠሪያ ማስገቢያ ሁኔታ ይቆጣጠሩ።",
      },
      PAYMENT: {
        TITLE: "የክፍያ ታሪክን ይመልከቱ",
        CONTENT:
          "የልጅዎን የገንዘብ ግንዛቤ ለመምራት የሚረዱ የልጅዎን ገቢዎች፣ የክፍያ ጊዜያት እና የክፍያ ቀናት ማጠቃለያዎችን ይድረሱባቸው።",
      },
      NOTIFICATIONS: {
        TITLE: "ማሳወቂያዎችን እና ማስጠንቀቂያዎችን ይቀበሉ",
        CONTENT:
          "ስለ ሥራ ምደባዎች፣ ችግሮች ወይም ቀጣይ ክስተቶች በተመለከተ ከDOES፣ ከፕሮግራም ሰራተኞች ወይም ከአስተናጋጆች የእውነተኛ ጊዜ ዝማኔዎችን ማግኘት ይቀጥሉ።",
      },
      AI_ASSISTANT: {
        TITLE: "ለድጋፍ ሰው ሰራሽ አዕምሮ ረዳትን ይጠቀሙ",
        CONTENT:
          "ስለ ፕሮግራሙ፣ ሰነዶች ወይም የጊዜ ሰሌዳዎች ጥያቄ አለዎት? ለአፋጣኝ መመሪያ የእኛን ምክትል ረዳት ይጠይቁ—24/7 ይገኛል።",
      },
      SECURITY: {
        TITLE: "ደህንነቱ የተጠበቀ መለያ መዳረሻ",
        CONTENT:
          "መለያዎ በብዙ ደረጃ ማረጋገጫ የተጠበቀ ነው፣ የቤተሰብዎ መረጃ ደህንነቱ የተጠበቀ እና ሚስጥራዊነቱ የተጠበቀ መሆኑን ያረጋግጣል።",
      },
    },
    NEXT_STEPS_TITLE: "ልጅዎ ከተመዘገበ በኋላ ምን ይሆናል?",
    NEXT_STEPS: [
      "የCYPMS መለያዎን ለመፍጠር የኢሜይል ግብዣ ይደርስዎታል",
      "የወላጅ ስምምነት ቅጹን ለማጽደቅ ይግቡ",
      "በስልጠና፣ በመቀበያ እና በምደባ አማካይነት እድገታቸውን ይቆጣጠሩ",
      "ፕሮግራሙ ሲጀምር የሰዓት መቆጣጠሪያዎችን እና የክፍያ ዝርዝሮችን ይመልከቱ",
      "ከዝማኔዎች፣ መልዕክቶች እና የድጋፍ መሳሪያዎች ጋር ተሳትፎዎን ይቀጥሉ",
    ],
  },

  // Common elements
  COMMON: {
    BANNER_ALT_TEXT: {
      YOUTH: "የወጣቶች ፖርታል",
      HOST: "የአስተናጋጅ ፖርታል",
      ADMIN: "የአስተዳዳሪ ፖርታል",
      PARENT: "የወላጅ ፖርታል",
    },
  },
};

export default locale;
